module.exports = __webpack_public_path__ + "img/IMG_3515.66b65075.jpg";